module.exports = __webpack_public_path__ + "media/images/landing/studies/johany-f8b6417ab03557841e0b02693be97710.png";